"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divisionList = void 0;
exports.divisionList = [
    {
        label: 'EU',
        value: 'EU',
    },
    {
        label: 'UK',
        value: 'UK',
    },
    {
        label: 'US',
        value: 'US',
    },
    {
        label: 'Rise',
        value: 'Rise',
    },
    {
        label: 'Canada',
        value: 'Canada',
    },
    {
        label: 'Foundations',
        value: 'Foundations',
    },
    {
        label: 'Athletics',
        value: 'Athletics',
    },
    {
        label: 'BDSA',
        value: 'BDSA',
    },
    {
        label: 'GSA',
        value: 'GSA',
    },
    {
        label: 'Other',
        value: 'Other',
    },
    {
        label: 'AUS',
        value: 'AUS',
    },
];
//# sourceMappingURL=divisionList.js.map